import { Box, Text } from '@chakra-ui/react';

import type { ApiNotificationType } from '@izimi/api';
import { appEnv } from '@izimi/core';

export const UnsupportedNotification = ({ type }: { type: ApiNotificationType }) => {
  return appEnv === 'development' ? (
    <Box bg='green' my={1} p={4}>
      <Text color='white'>
        Missing type:
        {type}
      </Text>
    </Box>
  ) : null;
};
